// This directive will override the parent element's focus method.
//   Why?
// When we write components, we always have a wrapper element that is also the public API for the component.
//  e.g.: <sd-search></sd-search>
// Using this attribute directive on one of the top level nodes in the template for our components, it will reach
//  up into the wrapper element, set a focus handler, and do something we think is natural when .focus is invoked on the
//  outer element. This lets us setup predictable focus behavior on components without having to have external consumers
//  reach into our HTML structure.

import { LoggingService } from "../sdServices/loggingSvc";

// @ngInject
export let chainParentFocusDirective = function (loggingService: LoggingService) {
  return {
    restrict: "A",
    link: function (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
      element.parent()[0].focus = () => {
        let selector = attrs["sdChainParentFocus"];
        let children = element.parent().find(selector);
        if (!children.length) {
          loggingService.logWarning(
            `sd-chain-parent-focus: Selector ${selector} on element ${element
              .parent()
              .clone()
              .empty()
              .html()} did not resolve an element to chain focus to.`
          );
        } else {
          children.first().focus();
        }
      };
    }
  };
};
